import { Box, Tab, Tabs } from '@mui/material';

// tabs is object with constants whose value is numerical {PAGE1:1, PAGE2:3}
export const getInitalValidTabNumber = ({ tabNumber, stepperTabs }) => {
  const defaultTab = Number(stepperTabs[0]?.tabNumber || 1) || 1;

  if (!tabNumber) {
    return defaultTab;
  }

  const parsedTabNumber = Number(tabNumber);

  if (!Number.isInteger(parsedTabNumber)) {
    return defaultTab;
  }

  const validTabs = new Set(
    stepperTabs.map(({ tabNumber: stepTabNumber }) => stepTabNumber),
  );

  return validTabs.has(parsedTabNumber) ? parsedTabNumber : defaultTab;
};

function ArrowError({ children }) {
  const sx = {
    width: '20px',
    height: '20px',
    borderRadius: '10px',
    backgroundColor: '#FF0000',
    fontSize: '12px',
    color: '#ffffff',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    ml: 1,
  };
  return <Box sx={sx}>{children}</Box>;
}

export function ArrowTabGroup({ inner = false, ...props }) {
  return (
    <Tabs
      variant="fullWidth"
      scrollButtons="auto"
      textColor="inherit"
      TabIndicatorProps={{
        style: {
          display: 'none',
        },
      }}
      sx={{
        backgroundColor: inner ? 'stepperTrack' : 'stepperTrackActive',
        borderRadius: 1,
        minHeight: '20px',
        border: 0,
        boxShadow: 'none',
      }}
      {...props}>
      {props?.children}
    </Tabs>
  );
}

function ArrowTab(props) {
  const {
    label,
    selected,
    value,
    maxTabs,
    arrowHeadArea = 92,
    arrowBackArea = 8,
    errorCount = null,
    config = {},
    inner,
    ...other
  } = props;

  // const errorCount = props;

  const firstClipPath = `polygon(0% 0%, 85% 0%, ${arrowHeadArea}% 50%, 85% 100%, 0% 100%)`;
  const lastClipPath = `polygon(0% 0%, ${arrowBackArea}% 50%, 0% 100%, 100% 100%, 100% 0%)`;
  const middleClipPath =
    'polygon(0% 0%, 10% 50%, 0% 100%, 85% 100%, 95% 50%, 85% 0%)';

  const singleTab = maxTabs === 1;
  let clipPath;
  if (!singleTab) {
    clipPath = middleClipPath;
    if (value === 0) {
      clipPath = firstClipPath;
    } else if (value === maxTabs - 1) {
      clipPath = lastClipPath;
    }
  }

  const commonstyles = {
    minHeight: '40px',
    padding: '0 8px',
    lineHeight: '10px',
    height: '40px',
    cursor: 'pointer',
  };

  const Icon = config?.Icon || null;

  return (
    <Tab
      label={
        <Box
          sx={{
            fontWeight: 'normal',
            fontSize: '1em',
            alignItems: 'center',
            display: 'flex',
          }}>
          {Icon && <Icon sx={{ fontSize: '18px', mr: 0.3 }} />}
          {label}
          {errorCount && <ArrowError>{errorCount}</ArrowError>}
        </Box>
      }
      selected={selected}
      value={value}
      sx={
        selected
          ? {
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              ...(clipPath != null ? { clipPath } : {}),
              ...commonstyles,
            }
          : {
              ...commonstyles,
            }
      }
      {...other}
    />
  );
}

export default ArrowTab;
